import { MemberAlias } from '@nextforce/api'
import { makeStyles, Text } from '@rneui/themed'
import React, { useCallback } from 'react'
import { View } from 'react-native'
import { PressableOpacity } from 'shared/components/pressable_opacity'
import { getDarkShadeColor, getLightShadeColor } from 'shared/utils'
import { getAliasDisplayName } from '../member_alias'

interface Props {
  alias: MemberAlias
  onRemoved?: (alias: MemberAlias) => void
}

export function AliasSlug({ alias, onRemoved }: Props) {
  const styles = useStyles()
  const onPress = useCallback(() => onRemoved?.(alias), [alias, onRemoved])

  return (
    <View style={styles.container}>
      <View style={styles.chip}>
        <Text style={styles.aliasText} numberOfLines={1}>
          {getAliasDisplayName(alias)}
        </Text>
        {onRemoved && (
          <PressableOpacity style={styles.removeButton} onPress={onPress}>
            <Text style={styles.removeButtonText}>×</Text>
          </PressableOpacity>
        )}
      </View>
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 4,
  },
  chip: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: theme.colors?.primary,
    borderRadius: 16,
    paddingHorizontal: 12,
    paddingVertical: 6,
    maxWidth: '100%',
  },
  aliasText: {
    color: theme.colors?.white,
    fontSize: 12,
    fontWeight: '500',
    flex: 1,
  },
  removeButton: {
    marginLeft: 6,
    width: 16,
    height: 16,
    borderRadius: 8,
    backgroundColor: theme.mode==='dark'? getDarkShadeColor(): getLightShadeColor(),
    justifyContent: 'center',
    alignItems: 'center',
  },
  removeButtonText: {
    color: theme.colors?.white,
    fontSize: 12,
    fontWeight: 'bold',
    lineHeight: 12,
  },
}))
